import { Row } from 'twyne-new.ui';

import { Card, Property } from '@/components/reports/card';

import { CardTitle } from './utils'

export default function MetaFieldsResult({ data }) {
  const metaFields = Object.entries(data || {})

  if (!metaFields.length) return null

  return <Card title={<CardTitle title="Meta Fields" subtitle={`total: ${metaFields.length}`} />}>
    <Row>
      {metaFields.map(([key, value]) => <Property key={key} label={key} value={formatValue(value)} />)}
    </Row>
  </Card>
}

const formatValue = value => {
  if ([undefined, null, ''].includes(value)) return null
  if (typeof value === 'object') return JSON.stringify(value)
  return `${value}`
}
